var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c('b-row',{staticClass:"m-5 p5"},[_c('b-col',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"label":"Large Spinner","type":"grow"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }